import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';
import pako from 'pako';
import { LoaderService } from './loader.service';

declare var $: any;

@Injectable()
export class ApiService {
    // public base: string = "https://demo-tml.g10.pw/";
    // public base: string = "http://192.168.2.13:6025/"; // santhosh system
    // public base: string ="http://localhost:6025/";
    // public base = 'http://emps.g10.pw:6025/';

    
     //public base = 'https://api-emps.g10.pw/'; //production
    
     public base = 'https://qasapi-emps.g10.pw/';  //QAS
     // public base = "https://api.saferide.work/"  

    public token;
    public awsS3BugetURL = "https://s3.ap-south-1.amazonaws.com/dzrjjsqnpdynylcuvsgahznfioxxkjuj-emps.g10.pw/datalog/";
    // "https://s3.ap-south-1.amazonaws.com/ha7cj8rgnvsp2qwq-release-deskapp.placer.in/RND/",";
    // https://s3.ap-south-1.amazonaws.com/dzrjjsqnpdynylcuvsgahznfioxxkjuj-emps.g10.pw/datalog/020621/90265949471cbbc392e6bb804554f3a1ecf9ade6482b8bc3c23afa223574f942.z
    constructor(public http: HttpClient, public storage: StorageService,
        private loader: LoaderService) {
        this.token = this.storage.get('token');
    }

    // OrganizationCreate(data: any) {
    //     return this.post('master/organisation/create', data);
    // }

    // OrganizationUpdate(data: any) {
    //     return this.post('', data);
    // }

    // OrganizationFetch(data?: any) {
    //     return this.post('master/vieworganisation', data);

    // }


    // // -----------------USER------------------------
    // getOrganization(data: any) {
    //     return this.post('student/login',data);
    //     // return new Promise((resolve) => { console.log('API --->', data); resolve({ status: 'success' }) });
    // }
    // UserCreate(data: any) {
    //     // return this.post('student/login',data);
    //     return new Promise((resolve) => { console.log('API --->', data); resolve({ status: 'success' }) });
    // }


    // UserFetch() {
    //     // return this.post('student/login',data);
    //     return new Promise((resolve) => {
    //         resolve({
    //             status: 'success', data: {
    //                 userfirstname: "arun",
    //                 userlasttname: "kumar",
    //                 useremail: "arun@gmail.in",
    //                 userrole: "depotadmin",
    //                 usercontactno: "984543536363",
    //                 userid: "TC5-323",
    //                 userdesignation: "Depot Admin",
    //                 reportingmanager: "satish"

    //             }
    //         })
    //     });
    // }

    // Read-API
    uint8arrayToStringMethod(myUint8Arr: any) {
        return String.fromCharCode.apply(null, myUint8Arr);
    }
    readS3Data(url) {
        return new Promise((res, rej) => {
            try {
                const oReq = new XMLHttpRequest();
                oReq.open('GET', this.awsS3BugetURL + url, true);
                // oReq.open('GET', 'http://localhost:4201/'+ url, true);
                oReq.responseType = 'arraybuffer';
                let p = this;
                oReq.onload = function (oEvent) {
                    const arrayBuffer = oReq.response; // Note: not oReq.responseText
                    // console.log('Array Buf ', arrayBuffer)
                    if (oReq.status == 200 && oReq.readyState == 4) {
                        if ((arrayBuffer && arrayBuffer != undefined) && (oReq.status == 200 && oReq.readyState == 4)) {
                            const binData = new Uint8Array(arrayBuffer);
                            if (binData.length > 0) {
                                const data = pako.inflate(binData);
                                const uint8Array = new Uint8Array(data);
                                let finalData = null;
                                if (Array.isArray(uint8Array)) {
                                    finalData = uint8Array.reduce(function (acc, i) {
                                        return acc += String.fromCharCode.apply(null, [i]);
                                    }, '');
                                } else {
                                    // console.log('finalData', Object.keys(uint8Array),' ###### ', uint8Array)
                                    finalData = Object.keys(uint8Array).map(function (item) {
                                        return uint8Array[item];
                                    }).filter(function (notnull) {
                                        if (notnull != null) { return notnull; }
                                    }).reduce(function (acc, i) {
                                        acc += String.fromCharCode.apply(null, [i]);
                                        return acc;
                                    });
                                }
                                // console.log('Final DAta ', finalData);
                                if (finalData != undefined) {
                                    const subStr = finalData.substr(0, 1);
                                    let movementReportdata = '';
                                    if (subStr === '{') {

                                    } else {
                                        const split = finalData.split('"sdate"');
                                        split[0] = '{';
                                        if (split[1]) {
                                            split[1] = split[1].replace("}{", "}\n{");
                                        }
                                        finalData = split.join('"sdate"');
                                    }
                                    // console.log(' DATA  ', finalData);
                                    movementReportdata = '[' + finalData.split('\n').join(',') + '{}]';


                                    try {
                                        const commits = JSON.parse(movementReportdata);
                                        setTimeout(function () { res(commits); }, 200);

                                    } catch (er) { rej({}); }


                                    // console.log(movementReportdata);

                                } else {
                                    res({});
                                    // console.log('if else 1')
                                }
                            } else {
                                res({});
                                // console.log('if else 2')
                            }

                        } else {
                            // console.log('if else 3')
                            res({});
                        }
                    } else {
                        rej({});
                        // console.log('if else 4')
                    }
                    oReq.onerror = function (e) {
                        rej({});
                        console.log('error')
                    };
                };
                oReq.send(null);

            } catch (e) {
                console.log('Error ', e);
                res({});
            }
        });
    }



    // Reports API
    transportManagerComplaintRatings(data: any) {
        return this.post('organization/report/compRating', data);
    }

    
    // OPEN BOOKING REPORTS API 
    selectedEmployess(data: any) {
        return this.post("organization/employee/selectedEmployes", data);
    }
    selectedRoutes(data: any) {
        return this.post('organization/route/selectedRouteData', data);
    }
    getExcessEmployeeReport(data: any) {
        return this.post('organization/openbook/excessEmpReqTable', data);
    }
    getExcessEmployeeExlReports(data: any) {
        return this.post('organization/openbook/excessEmpReqExcel', data);
    }


    getEmployeeBookingReports(data: any) {
        return this.post("organization/openbook/getEmployeeBookingReports", data);
    }
    getEmployeeBookingExlReports(data: any) {
        return this.post("organization/openbook/getEmployeeBookingExcelReports", data);
    }
    getEmployeeBookingCount(data: any) {
        return this.post("organization/openbook/bookingCount", data);
    }
    getVehicleBookingReports(data: any) {
        return this.post("organization/openbook/getVehicleBookingReports", data);
    }
    getVehicleBookingExlReports(data: any) {
        return this.post("organization/openbook/getVehicleBookingExcelReports", data);
    }
    getRouteBookingReports(data: any) {
        return this.post("organization/openbook/getRouteBookingReports", data);
    }
    getRouteBookingExlReports(data: any) {
        return this.post("organization/openbook/getRouteBookingExcelReports", data)
    }
    transportManagerBookingCancel(data: any) {
        return this.post("employee/openbook/cancelBook", data);
    }
    // Head count 
    getHeadCountReports(data: any) {
        return this.post("organization/report/headCount", data)
    }
    // Geo entry exit 
    getGeoEntryExitReports(data: any) {
        return this.post("organization/report/geoEntryExit", data);
    }
    // safe drop
    getSafeDropExlReports(data: any) {
        return this.post("organization/report/safedrop", data);
    }
    getSafeDropReports(data: any) {
        return this.post("organization/report/safedropTable", data);
    }

    // App
    transportManagerEmpAppReports(data: any) {
        return this.post("organization/report/empAppInsTable", data);
    }
    transportManagerEmpAppExlReports(data: any) {
        return this.post("organization/report/empAppInsExcel", data);
    }
    transportManagerDriverAppReports(data: any) {
        return this.post("organization/report/driAppInsTable", data);
    }
    transportManagerDriverAppExlReports(data: any) {
        return this.post("organization/report/driAppInsExcel", data);
    }
    // harsh acceleration report 
    transportManagerHarshAccelerationReport(data: any) {
        return this.post("organization/report/harshAccBraking", data);
    }
    //sendOtp
    VerifyOTP(data: any) {
        return this.post('organization/notification/verify', data);
    }
    sendVerificationOTP(data: any) {
        return this.post('organization/notification/sendOtp', data);
    }
    getCompletedPPList(data: any) {
        return this.post('organization/dashboard/pickUpDropInfo', data);
    }
    addRoutePickupPoint(data: any) {
        return this.post('organization/route/createPickupPoint', data);
    }
    deleteRoutePickupPoint(data: any) {
        return this.post('organization/route/deletePickupPoint', data);
    }
    updateRoutePickupPoint(data: any) {
        return this.post('organization/route/updatePickupPoint', data);
    }
    addRouteAutoPickupPoint(data: any) {
        return this.post('organization/route/createManyPickupPoint', data);
    }
    listRoutePickupPoint(data: any) {
        return this.post('organization/route/listPickupPoint', data);
    }
    // -----------------------MASTER-------------------
    masterLogin(data: Object) {
        return this.post('master/login', data);
    }
    getMasterLoginData(data: Object) {
        return this.post('master/checkAdminExits', data);
    }
    getlink(data: Object) {
        return this.post('master/getAdminAccountActivationLink', data);
    }
    updatepassword(data: Object) {
        return this.post('master/activateAdminAccount', data);
    }
    org_settings(data: Object) {
        return this.post('master/organization/settings', data);
    }
    org_settingsList(data: Object) {
        return this.post('master/organization/settings_list', data);
    }
    org_settings_update(data: Object) {
        return this.post('master/organization/organizationSettingUpdate', data);
    }
    // GetCurUser(data: any) {
    //     return this.post('organization/getCurUser', data);
    // }
    // org api
    createOrg(data: Object) {
        return this.post('master/organization/create', data);
    }

    listOrg(data: Object) {
        return this.post('master/organization/list', data);
    }
    updateOrg(data: Object) {
        return this.post('master/organization/update', data);
    }
    deleteOrg(data: Object) {
        return this.post('master/organization/delete', data);
    }
    createUser(data: Object) {
        return this.post('user/create', data);
    }
    viewUser(data: Object) {
        return this.post('user/view', data);
    }
    // deleteUser(data: Object) {
    //     return this.post('user/delete', data);
    // }

    masterOrgAppInsCount(data: Object) {
        return this.post('organization/report/appInsCount', data);
    }
    masterOrgDataCount(data: any) {
        return this.post('master/dashboard/dataCount', data);
    }

    // Roster Template field Mapping
    masterRosterListMapping(data) {
        return this.post('master/fieldMapping/listRosterMapping', data);
    }

    masterRosterUpdateMapping(data) {
        return this.post('master/fieldMapping/updateRosterMapping', data);
    }

    masterRosterCreateMapping(data) {
        return this.post('master/fieldMapping/createRosterMapping', data);
    }

    masterOrgFieldMapSettingList(data) {
        return this.post('master/organization/organizationSettingList', data)
    }

    // -----------------------------Transport-Manager-----------------------
    transportManagerLogin(data: Object) {
        return this.post('organization/login', data);
    }
    GetCurUserOrg(data: any) {
        return this.post('organization/organization/getCurUser', data);
    }
    GetCurUserVendor(data: any) {
        return this.post('organization/vendor/getCurUser', data);
    }
    getNotificationData(data: any) {
        return this.post('organization/notification/getAllNotification', data);
    }
    orgForgotPassword(data: any) {
        return this.post('organization/organization/forgetPassword', data);
    }
    orgCreatePassword(data: any) {
        return this.post('organization/organization/createNewPassword', data);
    }
    empForgotPassword(data: any) {
        return this.post('employee/app/forgetPassword', data);
    }
    empCreatePassword(data: any) {
        return this.post('employee/app/createNewPassword', data);
    }
    changePassword(data: any) {
        return this.post('organization/organization/changePassword', data);
    }
    updateCurUserOrg(data: any) {
        return this.post('organization/organization/adminUpdate', data);
    }

    // -----------------------------------------------------------------------------------

    // ------------------- Vendor Module -------------------------------------------------

    vendorForgotPassword(data: any) {
        return this.post('organization/vendor/forgetPassword', data);
    }
    vendorCreatePassword(data: any) {
        return this.post('organization/vendor/createNewPassword', data);
    }
    vendorChangePassword(data: any) {
        return this.post('organization/vendor/changePassword', data);
    }

    // -----------------------------------------------------------------------------------

    // ------------------- Map Url ---------------------------------

    empsOsrmUrl(data: object) {
        return this.post('organization/rostering/osrmUrl', data);
    }
    // -------------------------------------------------------------


    // ------------------- vendor api's ----------------------------
    transportManagerVendorCreate(data: Object) {
        return this.post('organization/vendor/create', data);
    }
    transportManagerVendorList(data: Object) {
        return this.post('organization/vendor/list', data);
    }
    transportManagerVendorDelete(data: Object) {
        return this.post('organization/vendor/delete', data);
    }
    transportManagerVendorUpdate(data: Object) {
        return this.post('organization/vendor/update', data);
    }
    // ------------------------------------------------------------

    // Vehicle api's ------------------------------------------------
    transportManagerVehicleCreate(data: Object) {
        return this.post('organization/vehicle/create', data);
    }
    transportManagerFormDataCreate(data: Object, url, cb) {
        return this.formDataCreation(url, data, cb);

    }
    transportManagerVehicleList(data: Object) {
        return this.post('organization/vehicle/list', data);
    }
    transportManagerVehicleDelete(data: Object) {
        return this.post('organization/vehicle/delete', data);
    }
    transportManagerVehicleUpdate(data: Object) {
        return this.post('organization/vehicle/update', data);
    }
    transportManagerVehicleCapacity(data: Object) {
        return this.post('organization/settings/commonList', data);
    }
    // ---------------------------------------------------------------
    // Driver api's ------------------------------------------------
    transportManagerDriverCreate(data: Object) {
        return this.post('organization/driver/create', data);
    }
    transportManagerDriverList(data: Object) {
        return this.post('organization/driver/list', data);
    }
    transportManagerDriverListHl(data: Object) {
        return this.post('organization/driver/list/hl', data);
    }
    transportManagerDriverDelete(data: Object) {
        return this.post('organization/driver/delete', data);
    }
    transportManagerDriverUpdate(data: Object) {
        return this.post('organization/driver/update', data);
    }
    // ---------------------------------------------------------------
    // manage vehicle & Driver
    transportManagerAssignVehicleDriver(data: Object) {
        return this.post('organization/organization/assignDriverVeh', data);
    }
    transportManagerManageVehicleDriverList(data: Object) {
        return this.post('organization/organization/driverVehList', data);
    }
    transportManagerManageVehicleDriverUpdate(data: Object) {
        return this.post('organization/organization/driverVehUpdate', data);
    }
    transportMangerManageVehicleDriverDelete(data: Object) {
        return this.post('organization/organization/driverVehDelete', data);
    }
    transportManagerAssignedVehDriverList(data: Object) {
        return this.post('organization/organization/assignedList', data);
    }
    transportManagerAssignedVehDriverListHl(data: Object) {
        return this.post('organization/organization/assignedList/hl', data);
    }
    transportManagerUnassignVehList(data: Object) {
        return this.post('organization/organization/unAssVehicle', data);
    }
    transportManagerUnassignDriverList(data: Object) {
        return this.post('organization/organization/unAssDriver', data);
    }

    // ---------------------------------------------------------------
    // Branch api's ------------------------------------------------
    transportManagerBranchExcelDownload(data: Object) {
        return this.post('organization/branch/listExcel', data);    
    }
    transportManagerBranchCreate(data: Object) {
        return this.post('organization/branch/create', data);
    }
    transportManagerBranchList(data: Object) {
        return this.post('organization/branch/list', data);
    }
    transportManagerBranchDelete(data: Object) {
        return this.post('organization/branch/delete', data);
    }
    transportManagerBranchUpdate(data: Object) {
        return this.post('organization/branch/update', data);
    }
    // Zone api's ------------------------------------------------
    transportManagerZoneCreate(data: Object) {
        return this.post('organization/nodal/create', data);
    }
    transportManagerZoneList(data: Object) {
        return this.post('organization/nodal/list', data);
    }
    transportManagerZoneDelete(data: Object) {
        return this.post('organization/nodal/delete', data);
    }
    transportManagerZoneUpdate(data: Object) {
        return this.post('organization/nodal/update', data);
    }
    // Branch api's ------------------------------------------------
    transportManagerLocationCreate(data: Object) {
        return this.post('organization/location/create', data);
    }
    transportManagerLocationList(data: Object) {
        return this.post('organization/location/list', data);
    }
    transportManagerLocationDelete(data: Object) {
        return this.post('organization/location/delete', data);
    }
    transportManagerLocationUpdate(data: Object) {
        return this.post('organization/location/update', data);
    }
    // Guest api's ------------------------------------------------
    transportManagerGuestCreate(data: Object) {
        return this.post('organization/guest/create', data);
    }
    transportManagerGuestList(data: Object) {
        return this.post('organization/guest/list', data);
    }
    transportManagerGuestDelete(data: Object) {
        return this.post('organization/guest/delete', data);
    }
    transportManagerGuestUpdate(data: Object) {
        return this.post('organization/guest/update', data);
    }

    // user api

    transportManagerUserCreate(data: Object) {
        return this.post('organization/organization/memberCreate', data);
    }

    // transportManagerUserDelete(data: Object) {
    //     return this.post('organization/organization/memberDelete', data);
    // }
    transportManagerUserList(data: Object) {
        return this.post('organization/organization/memberList', data);
    }

    transportManagerUserUpdate(data: Object) {
        return this.post('organization/organization/memberUpdate', data);
    }
    // Parking api's ------------------------------------------------
    transportManagerParkingCreate(data: Object) {
        return this.post('organization/parking/create', data);
    }
    transportManagerParkingList(data: Object) {
        return this.post('organization/parking/list', data);
    }
    transportManagerParkingDelete(data: Object) {
        return this.post('organization/parking/delete', data);
    }
    transportManagerParkingUpdate(data: Object) {
        return this.post('organization/parking/update', data);
    }

    // Notification Api's -------------------------------------------
    transportManagerNotificationCreate(data: Object) {
        return this.post('organization/notification/create', data);
    }
    transportManagerNotificationList(data: Object) {
        return this.post('organization/notification/list', data);
    }
    transportManagerNotificationUpdate(data: Object) {
        return this.post('organization/notification/update', data);
    }

    // Notification Settings config Api's
    transportManagerNotificationSettingCreate(data: Object) {
        return this.post('organization/notification/vehcreate', data)
    }
    transportManagerNotificationSettingList(data: Object) {
        return this.post('organization/notification/vehlist', data)
    }
    transportManagerNotificationSettingUpdate(data: Object) {
        return this.post('organization/notification/vehupdate', data)
    }
    transportManagerNotificationSettingDelete(data: Object) {
        return this.post('organization/notification/vehdelete', data)
    }
    // Org Notification Config Api's
    transportManagerNotificationConfig(data: Object) {
        return this.post('organization/notification/configMobEmail', data);
    }

    //org Notification ManageGroup API's

    transportManagerManageGroupCreate(data: Object) {
        return this.post('organization/notification/groupCreate', data)
    }
    transportManagerManageGroupList(data: Object) {
        return this.post('organization/notification/groupList', data)
    }

    transportManagerManageGroupUpdate(data: Object) {
        return this.post('organization/notification/groupUpdate', data)
    }

    transportManagerManageGroupDelete(data: Object) {
        return this.post('organization/notification/groupDelete', data)
    }
    //-----------------------------------------------------------------

    // -------------------- Connect call ------------------------------

    transportManagerConnectCall(data: Object) {
        return this.post('organization/information/connectCall', data);
    }


    // --------------------Dashboard Route Information-----------------

    // Summary Dashboard
    transportManagerRouteInformationSummary(data: Object) {
        return this.post('organization/dashboard/routeInfo', data);
    }
    transportManagerRouteSummary(data: Object) {
        return this.post('organization/route/tripSummary', data);
    }
    transportManagerDashboardRouteSummary(data: Object) {
        return this.post('organization/dashboard/routeSummary', data);
    }
    //  Active Routes
    transportManagerRouteInformation(data: Object) {
        return this.post('organization/dashboard/getActiveRoutes', data);
    }
    // get pickuppoints counts
    transportManagerRouteInfoPPcounts(data: Object) {
        return this.post('organization/dashboard/pickUpDropCount', data);
    }

    // Employee -----------------------------------------------------
    transportManagerEmployeeCreate(data: Object) {
        return this.post('organization/employee/create', data);
    }
    transportManagerEmployeeList(data: Object) {
        return this.post('organization/employee/list', data);
    }
    transportManagerEmployeeListHl(data: Object) {
        return this.post('organization/employee/list/hl', data);
    }
    transportManagerEmployeeDelete(data: Object) {
        return this.post('organization/employee/delete', data);
    }
    transportManagerEmployeeUpdate(data: Object) {
        return this.post('organization/employee/update', data);
    }

    listBranches(data: Object) {
        return this.post('organization/branch/list', data);
    }
    getEmployeeFilter(data: any) {
        return this.post('organization/employee/getEmployeeFilter', data);
    }
    filterEmployees(data: Object) {
        return this.post('organization/employee/employeeSearch', data);
    }
    employeeSendMail(data: any) {
        return this.post('organization/employee/sendgmail', data)
    }
    // --------------------------------------------------------------------

    // Escort API
    transportManagerEscortCreate(data: Object) {
        return this.post('organization/escort/create', data);
    }
    transportManagerEscortList(data: Object) {
        return this.post('organization/escort/list', data);
    }
    transportManagerEscortDelete(data: Object) {
        return this.post('organization/escort/delete', data);
    }
    transportManagerEscortUpdate(data: Object) {
        return this.post('organization/escort/update', data);
    }
    // ------------------------- route / rostering ------------------------

    transportManagerRosteringDashboard(data) {
        return this.post('organization/rostering/dashboard', data);
    }

    transportMangerRouteCreate(data) {
        return this.post('organization/route/create', data);
    }
    transportMangerRouteList(data) {
        return this.post('organization/route/list', data);
    }
    transportMangerRouteDelete(data) {
        return this.post('organization/route/delete', data);
    }
    transportMangerRouteUpdate(data) {
        return this.post('organization/route/update', data);
    }
    transportManagerRouteAvailableVeh(data) {                            // check currently working
        return this.post('organization/route/availableVehicle', data);
    }
    transportManagerRouteEdit(data) {
        return this.post('organization/route/editRost', data);
    }
    transportManagerRouteStatusUpdate(data) {
        return this.post('organization/route/tripStatus', data);
    }

    transportManagerRouteVehicleSwap(data: Object) {
        return this.post('organization/vehicle/tempVehicle', data);
    }

    transportManagerRouteTripDelete(data: Object) {
        return this.post('organization/route/tripDelete', data);
    }

    transportManagerRegularRouteAvailableVeh(data: Object) {
        return this.post('organization/vehicle/availableVehReg', data);
    }

    transportManagerOccasionalRouteAvailableVeh(data: Object) {
        return this.post('organization/vehicle/availableVehOcc', data);
    }
    transportManagerEditRouteAvailableVeh(data: Object) {
        return this.post('organization/vehicle/availableVeh', data);
    }
    transportManagerOBRouteAvailableVeh(data: any) {
        return this.post('organization/vehicle/availableVehOB', data);
    }
    // Open Booking Route
    transportManagerOpenBookingRouteCreate(data: Object) {
        return this.post('organization/openbook/create', data);
    }
    transportManagerOpenBookingRouteList(data: Object) {
        return this.post('organization/openbook/list', data);
    }
    transportManagerOpenBookingRouteUpdate(data: Object) {
        return this.post('organization/openbook/update', data);
    }
    transportManagerOpenBookingRouteDelete(data: Object) {
        return this.post('organization/openbook/delete', data);
    }
    transportManagerOpenBookingRouteSearch(data: Object) {
        return this.post('organization/openbook/search', data);
    }
    transportManagerOpenBookingRouteCreatePP(data: Object) {
        return this.post('organization/openbook/createPp', data);
    }
    transportManagerOpenBookingRouteListPP(data: Object) {
        return this.post('organization/openbook/listPp', data);
    }
    transportManagerOpenBookingRouteUpdatePP(data: Object) {
        return this.post('organization/openbook/updatePp', data);
    }
    transportManagerOpenBookingRouteDeletePP(data: Object) {
        return this.post('organization/openbook/deletePp', data);
    }
    //Excel download
    transportManagerRouteWiseExlReport(data: Object) {
        return this.post('organization/route/routeExDownload', data);
    }
    transportManagerRouteVehicleWiseExlReport(data: Object) {
        return this.post('organization/route/vehExDownload', data);
    }

    //Roster
    transportManagerRosterList(data) {
        return this.post('organization/route/listRost', data);
    }
    transportManagerRosterUpdate(data) {
        return this.post('organization/route/updateRost', data);
    }
    transportManagerRosterMerge(data) {
        return this.post('organization/route/mergeRost', data);
    }
    transportManagerChangeVehicle(data) {
        return this.post('organization/route/changeVehicle', data);
    }
    transportManagerRosterSummary(data) {
        return this.post('organization/route/summary', data);
    }
    transportManagerRosterRouteDelete(data) {
        return this.post('organization/route/deleteRost', data);
    }
    transportManagerReportTrip(data) {
        return this.post('organization/report/tripReport', data);
    }
    transportManagerGroupRevert(data) {
        return this.post('organization/route/revertGrouping', data);
    }
    transportManagerGroupCancel(data) {
        return this.post('organization/route/cancelGrouping', data);
    }

    // Route cutoff
    transportManagerRouteCutoffCreate(data: Object) {
        return this.post('organization/route/createCT', data);
    }

    transportManagerRouteCutoffList(data: Object) {
        return this.post('organization/route/listCT', data);
    }
    transportManagerRouteCutoffRevert(data: Object) {
        return this.post('organization/route/revertCT', data);
    }

    //Holiday Update
    transportManagerRouteHolidayUpdate(data: Object) {
        return this.post("organization/settings/holidayUpdate", data);
    }
    transportManagerRouteHolidayList(data: Object) {
        return this.post("organization/settings/holidayList", data);
    }


    // ----------------------------Favourite Location-----------------------

    transportManagerFavouriteLocationCreate(data: Object) {
        return this.post('organization/favloc/create', data);
    }
    transportManagerFavouriteLocationList(data: Object) {
        return this.post('organization/favloc/list', data);
    }
    transportManagerFavouriteLocationUpdate(data: Object) {
        return this.post('organization/favloc/update', data);
    }
    transportManagerFavouriteLocationDelete(data: Object) {
        return this.post('organization/favloc/delete', data);
    }

    // -----------------------------Route PP Start and End Location---------

    transportManagerRouteStEndLocCreate(data: Object) {
        return this.post('organization/route/createStEndLoc', data);
    }
    transportManagerRouteStEndLocList(data: Object) {
        return this.post('organization/route/listStEndLoc', data);
    }
    transportManagerRouteStEndLocUpdate(data: Object) {
        return this.post('organization/route/updateStEndLoc', data);
    }
    transportManagerRouteStEndLocDelete(data: Object) {
        return this.post('organization/route/deleteStEndLoc', data);
    }

    // ----------------------------Reports----------------------------------
    transportManagerReportDataList(data: any) {
        return this.post('organization/report/overspeed', data);
    }
    transportManagerEmpAttendanceReport(data: any) {
        return this.post('organization/report/empAttendanceTable', data);
    }
    transportManagerEmpAttendanceExlReport(data: any) {
        return this.post('organization/report/empAttendanceExcel', data);
    }
    // ----------------------------Vehicle Audit---------------------------------

    transportManagerVehicleAuditList(data: any) {
        return this.post('organization/report/auditList', data)
    }
    // ----------------------------Campaign---------------------------------

    transportManagerCampaignTemplateCreate(data) {
        return this.post('organization/campaign/createTemplete', data);
    }
    transportManagerCampaignTemplateList(data) {
        return this.post('organization/campaign/listTemplete', data);
    }
    transportManagerCampaignTemplateUpdate(data) {
        return this.post('organization/campaign/updateTemplete', data);
    }
    transportManagerCampaignTemplateDelete(data) {
        return this.post('organization/campaign/deleteTemplete', data);
    }

    // -----------------------------vendor----------------------------------
    vendorLogin(data: Object) {
        return this.post('organization/vendor/login', data);
    }
    // -------------------------------------------------------------

    // Feedback -------------------------------------------------
    FeedbackCreate(data: Object) {
        return this.post('organization/supportdesk/createFeedback', data);
    }
    FeedbackList(data: Object) {
        return this.post('organization/supportdesk/viewFeedback', data);
    }
    FeedbackUpdate(data: Object) {
        return this.post('organization/supportdesk/updateFeedback', data);
    }
    FeedbackDelete(data: Object) {
        return this.post('organization/supportdesk/deleteFeedback', data);
    }
    // -----------------------------------------------------------

    // --------------------- Complaints --------------------------

    transportManagerComplaintList(data: Object) {
        return this.post('organization/complaint/list', data);
    }
    transportManagerComplaintUpdate(data: Object) {
        return this.post('organization/complaint/update', data);
    }
    transportManagerComplaintListCount(data: Object) {
        return this.post('organization/complaint/listCount', data);

    }

    // -----------------------------------------------------------

    //  -------------------- Request -----------------------------

    getOrgVehicleRegNos(data: any) {
        return this.post('organization/organization/getActiveRegNo', data);
    }
    CreateRequest(data: Object) {
        return this.post('organization/request/create', data);
    }
    ListRequest(data: Object) {
        return this.post('organization/request/list', data);
    }

    UpdateRequest(data: Object) {
        return this.post('organization/request/update', data);
    }
    DeleteRequest(data: Object) {
        return this.post('organization/request/delete', data);
    }

    RequestResList(data: Object) {
        return this.post('organization/request/listApp', data);
    }
    RequestResUpdate(data: Object) {
        return this.post('organization/request/updateApp', data);
    }

    statusUpdate(data: any) {
        return this.post('organization/statusUpdate', data);
    }
    // customRequest---------------------------------
    CreateCustomRequest(data: any) {
        return this.post('organization/request/createCustomRequest', data);
    }
    ListCustomRequest(data: any) {
        return this.post('organization/request/viewCustomRequest', data);
    }
    UpdateCustomRequest(data: any) {
        return this.post('organization/request/updateCustomRequest', data);
    }
    DeleteCustomRequest(data: any) {
        return this.post('organization/request/deleteCustomRequest', data);
    }
    RequestResExcel(data: any) {
        return this.post('organization/request/listAppExcel', data);
    }

    addHolidays(data: Object) {
        return this.post('organization/holiday/create', data);
    }
    getHolidays(data: Object) {
        return this.post('organization/holiday/list', data);
    }
    deleteHolidays(data: Object) {
        return this.post('organization/holiday/delete', data);
    }


    getCurrentLocation(data: any) {
        return this.post('organization/organization/getCurrentLocation', data);
    }
    // -----------------------------------------------------
    // shift ---------------------------------
    DeleteShift(data: any) {
        return this.post('organization/organization/deleteShift', data);
    }
    CreateShift(data: any) {
        return this.post('organization/organization/createShift', data);
    }
    UpdateShift(data: any) {
        return this.post('organization/organization/updateShift', data);
    }
    ListShift(data: any) {
        return this.post('organization/organization/listShift', data);
    }


    // ------------------------------------------------
    // ------get nearest location for given emp location-------
    GetNearestLocation(data: any) {
        return this.post('organization/algorithm/getNearestLocationList', data);
    }

    //--------Generate route with Nextmv----------------
    RouteGenerate(data: any) {
        return this.post('organization/organization/routing', data);
    }


    //    SOS Panel location 

    getSOSLists(data: any) {
        return this.post("organization/sos/getReports", data);
    }

    getSosAlerts(data: any) {
        return this.post("organization/sos/listActionSosData", data);
    }
    updateSosAlerts(data: any) {
        return this.post("organization/sos/updateAction", data);
    }
    sosClickToCall(data: any) {
        return this.post("organization/organization/clickToCall", data);
    }

    sosNearByEmployee(data: any) {
        return this.post("organization/sos/nearByEmpVeh", data);
    }

    getSOSViewData(data: any) {
        return this.post("organization/sos/viewSosData", data);
    }
    sosNearByEmployeeHl(data: any) {
        return this.post("organization/sos/nearByEmpVeh/hl", data);
    }

    getSOSViewDataHl(data: any) {
        return this.post("organization/sos/viewSosData/hl", data);
    }

    // End SOS panel APIS

    // Sos Reports

    getSOSReportList(data: any) {
        return this.post('organization/report/sosList', data);
    }

    // towalert reports
    getTowAlertReportList(data: any) {
        return this.post('organization/report/towAlertReport', data);
    }

    // homepage request demo

    homepageRequestDemoForm(data: any) {
        return this.post("organization/home/createEnquiry", data);
    }

    /* Excel file upload */
    xlsxFileUpload(data: Object, url: string, id: string, cb) {
        // console.log('dataaaaaaaaa '+data);
        return this.fileUpload(url, data, id, cb);
    }

    getTrackingData(data: any) {
        return this.post('organization/dashboard/vehicleTrackingData', data);
    }
    getVehicleRegNo(data: any) {
        return this.post('organization/dashboard/VehicleEncryptedKey', data);
    }

    /* API without loader */
    // using hl in End of URL for remove loader
    transportMangerRouteSearch(data) {
        return this.post('organization/route/list/hl', data);  // hl - Hide Loader
    }
    transportMangerHolidaySearch(data) {
        return this.post('organization/holiday/list/hl', data);  // hl - Hide Loader
    }
    transportManagerRouteVehSearch(data: any) {
        return this.post('organization/route/searchVehicle/hl', data); // hl - Hide Loader
    }
    transportManagerRoutePPSearch(data: any) {
        return this.post('organization/route/searchPickuppoint/hl', data);
    }
    transportManagerRouteEmpSearch(data: any) {
        return this.post('organization/route/searchEmployee/hl', data);
    }
    transportManagerRosterRouteDeleteHl(data) {
        return this.post('organization/route/deleteRost/hl', data);
    }
    transportManagerRosterMergeHl(data) {
        return this.post('organization/route/mergeRost/hl', data);
    }

    transportManagerRouteVehList(data: any) {
        return this.post('organization/route/searchVehicle', data);
    }
    transportManagerRoutePPList(data: any) {
        return this.post('organization/route/searchPickuppoint', data);
    }

    /* Global Settings */
    // Mail configuration
    transportManagerGblSetMailConfigCreate(data: any) {
        return this.post("organization/settings/createSub", data);
    }
    transportManagerGblSetMailConfigList(data: any) {
        return this.post("organization/settings/listSub", data);
    }
    transportManagerGblSetMailConfigUpdate(data: any) {
        return this.post("organization/settings/updateSub", data);
    }

    //Booking Day configuration
    transportManagerGblSetBookingDayConfigCreate(data: any) {
        return this.post("organization/settings/seatBookLimitCreate", data);
    }
    transportManagerGblSetBookingDayConfigList(data: any) {
        return this.post('organization/settings/seatBookLimitList', data);
    }
    transportManagerGblSetBookingDayConfigUpdate(data: any) {
        return this.post("organization/settings/seatBookLimitUpdate", data);
    }

    // Open Booking Status
    transportManagerGblSetOpenBookingStatusCreate(data: any) {
        return this.post("organization/settings/openBookCreate", data);
    }
    transportManagerGblOpenBookingStatusUpdate(data: any) {
        return this.post("organization/settings/openBookUpdate", data);
    }
    transportManagerGlbOpenBookingStatusList(data: any) {
        return this.post("organization/settings/openBookList", data);
    }

    //google map click to find location
    transportManagerGoogleMapGeocoder(data: any) {
        return this.post("organization/map/googleGeocoder", data)
    }

    //new
    transportManagerGrouping(data: any) {
        return this.post("organization/route/filterRost", data);
    }
    transportManagerEditGrouping(data: any) {
        return this.post("organization/route/groupingRoster", data);
    }
    transportManagerOverallVehList(data: any) {
        return this.post("organization/vehicle/vehList", data);
    }
    transportManagerCheckIn(data: any) {
        return this.post("organization/vehicle/vehCheckIn", data);
    }
    transportManagerCheckInOutList(data: any) {
        return this.post("organization/vehicle/vehCheckInOutList", data);
    }
    transportManagerCheckOut(data: any) {
        return this.post("organization/vehicle/vehCheckOut", data);
    }

    
    //createRoster/employeeList
    transportManagerGetEmployeeList(data: any) {
        return this.post("organization/createRoster/employeeList", data);
    }
    transportManagerExcelFileNameHl(data: any) {
        return this.post("organization/route/uploadFileName/hl", data);
    }
    transportManagerEscortCheckIn(data: any) {
        return this.post("organization/escort/checkIn", data);
    }
     //bulk assign multiple cabs
    transportManagerBulkCabAssignment(data: any) {
        return this.post("organization/route/groupingRoster", data);
    }
    transportManagerEscortCheckOut(data: any) {
        return this.post("organization/escort/checkOut", data);
    }
    transportManagerEscortCheckInOutList(data: any) {
        return this.post("organization/escort/escortCheckInOutList", data);
    }
    // userURLListRequest(data:any){
    //     return this.post("organization/request/GHRMSRequestList",data);
    // }
    transportManagerEmployeeSubmitRequest(data: any) {
        return this.post("employee/request/employeeSubmitRequest", data);
    }
    transportManagerEmployeeTripUpdate(data: any) {
        return this.post("employee/request/employeeURLSubmitRequest", data);
    }
    transportManagerRosterBranchList(data: any) {
        return this.post("employee/request/branchList", data);
    }
    transportManagerRosterAddEmployee(data: any) {
        return this.post("organization/route/employeeAdd", data);
    }
    transportManagerRosterAdhocEmployeeList(data: any) {
        return this.post("organization/route/empAdhocList", data);
    }
    transportManagerRosterAdhocAllEmployeeList(data: any) {
        return this.post("organization/route/adhocEmpRescheduleList", data);
    }
    transportManagerRosterRouteCreate(data) {
        return this.post('organization/route/createRoster', data);
    }
    transportManagerRosterTriggerNotificationToDriver(data) {
        return this.post('organization/route/triggerNotification', data);
    }
    transportManagerAllVehicleList(data) {
        return this.post('organization/vehicle/vehicleList', data)
    }
    transportManagertripEnd(data) {
        return this.post('organization/route/adminTripStatus', data)
    }
    transportManagerAllAssignedVehicleDash(data) {
        return this.post('organization/organization/assignedListDashboard', data)
    }
    transpportManagerAllEscortList(data) {
        return this.post('organization/escort/newEscortList', data)
    }

    // Overspeed alerts data  
    transportOverSpeedAlerts(data: any) {
        return this.post("organization/report/overSpeedAlert", data)
    }
    // geofence 
    transportManagerGeofenceCreate(data: any) {
        return this.post("organization/geofence/create", data);
    }
    transportManagerGeofenceList(data: any) {
        return this.post("organization/geofence/list", data)
    }
    transportManagerGeofenceUpdate(data: any) {
        return this.post("organization/geofence/update", data)
    }
    transportManagerGeofenceDelete(data: any) {
        return this.post("organization/geofence/delete", data)
    }
    transportManagerDriverAppUsageData(data: any) {
        return this.post("organization/report/mobileUsageTime", data)
    }
    // Driver app usage report
    getDriverAppUsageExl(data: any) {
        return this.post('organization/report/mobileUsageTimeExcel', data)
    }

    // vehicle list excel download
    transportMangerVehicleListExcel(data) {
        return this.post('organization/vehicle/vehListExcel', data)
    }
    transportMangerDriverListExcel(data) {
        return this.post('organization/driver/driverListExcel', data)
    }
    post(url: string, params: any) {
        try {
            // this.loader.show();
            // const data = params;
            const sanitizedParams = this.sanitizeParams(params);
            let headers: any = new HttpHeaders();
            headers = headers.set('Content-Type', 'application/json; charset=utf-8');
            headers = headers.set('Content-Security-Policy', "default-src 'self'");

            // Optionally, you can also set other security headers
            headers = headers.set('X-Content-Type-Options', 'nosniff');
            headers = headers.set('X-Frame-Options', 'DENY');
            headers = headers.set('Strict-Transport-Security', 'max-age=31536000; includeSubDomains');
            // headers = headers.set('origin', "https://dashboard.saferide.work/");
            return this.http.post(this.base + url, sanitizedParams, headers)
                .toPromise()
                .catch(error => {
                    console.error('Post request failed:', error);
                    throw error;
                });
        } catch (error) {
            // this.loader.hide();
            console.error('Unexpected error:', error);
            throw error;
        }

    }

    get(url: string) {
        try {
            return this.http.get(url);
        } catch (error) {
            console.log(error);
        }
    }


    fileUpload(url: string, params: any, inputID: string, cb) {

        try {
            let form: any = document.querySelector('#' + inputID);
            form = form.files[0];
            if (form !== undefined) {
                var formData = new FormData();
                formData.append("files", form, form.name);
                // params.vendorID && formData.append('vendorID',params.vendorID);
                let apiToken = this.storage.get('token');
                if (Object.keys(params).length > 0) {
                    if (params['vendorID']) apiToken = apiToken + '$vID$' + params.vendorID;
                    Object.keys(params).map((item) => {
                        if (Object.keys(params[item]).length > 0 || Array.isArray(params[item])) params[item] = JSON.stringify(params[item]);
                        formData.append(item, params[item])
                    });
                }
                // console.log("final output",formData);
                $.ajaxSetup({
                    beforeSend: function (xhr) {
                        xhr.setRequestHeader('token', apiToken);
                    }
                });
                $.ajax({
                    url: this.base + url,
                    type: 'POST',
                    data: formData,   // Tell jQuery not to process data or worry about content-type
                    cache: false,
                    contentType: false,
                    processData: false, // You must include these options              
                    //   beforeSend: function(xhr){
                    //                 xhr.setRequestHeader('token',apiToken);
                    //                 // xhr.setRequestHeader('vendorID',params.vendorID);
                    //             },
                    complete: (res) => {
                        cb(res);
                    }
                });

            } else {
                cb({ status: 'failure', data: 'Please select file.' });
            }
        } catch (error) {
            cb(error);
        }
    }

    formDataCreation(url: string, params: any, cb) {

        try {
            this.loader.show();
            var formData = new FormData();
            let apiToken = this.storage.get('token');
            if (Object.keys(params).length > 0) {
                Object.keys(params).map((item) => {
                    if (Object?.keys(params[item])?.length > 0 || Array.isArray(params[item])) params[item] = JSON.stringify(params[item]);
                    formData.append(item, params[item])
                });
            }
            // formData.forEach((value, key) => {
            //     console.log(`${key} key:`, value);
            //   });
            $.ajaxSetup({
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('token', apiToken);
                }
            });
            $.ajax({
                url: this.base + url,
                type: 'POST',
                data: formData,   // Tell jQuery not to process data or worry about content-type
                cache: false,
                contentType: false,
                processData: false, // You must include these options              
                //   beforeSend: function(xhr){
                //                 xhr.setRequestHeader('token',apiToken);
                //                 // xhr.setRequestHeader('vendorID',params.vendorID);
                //             },
                complete: (res) => {
                    this.loader.show();
                    cb(res);
                }
            });
        } catch (error) {
            this.loader.show();
            console.log("errorr", error)
            cb(error);
        }
    }
    private sanitizeParams(params: any) {
        if (typeof params == 'object' && params != null) {
            for (const key in params) {
                if (typeof params[key] == 'string') {
                    // Example: Remove Windows file paths from strings
                    params[key] = params[key].replace(/C:\\[^\\]+/, '');
                }
            }
        }
        return params;
    }

    // post2(url: string, params: any) {
    //     try {
    //         var data = params;
    //         let headers: any = new HttpHeaders();




    //         // headers = headers.set('Content-Type', 'application/json; charset=utf-8');

    //         // const headerOptions:any = {
    //         //     headers: new HttpHeaders({
    //         //         "Access-Control-Allow-Origin": "*",
    //         //         'Content-Type': 'application/json; charset=utf-8',
    //         //         "Access-Control-Allow-Methods": "GET,HEAD,OPTIONS,POST,PUT, DELETE",
    //         //         'Token': this.token
    //         //     })

    //         // }
    //         // console.log(headerOptions.headers)

    //         return this.http.post(this.base + url, data, headers)
    //             .toPromise()
    //             .then()
    //             .catch()
    //     } catch (error) {
    //         console.log(error)
    //     }

    // }

}
